<template>
 <div class="subtitle">
   <slot/>
 </div>
</template>
<script>

export default {
  name: 'Subtitle'
}

</script>
